import GuidePage from '../_GuidePage'
import GuideBody from '../_GuideBody'
import { useI18n } from '../../_i18n'
import { guideContent } from '../content'

// One data-driven page for every guide. The controller passes the `slug`; the
// content (title/description/body) comes from the localized guide-content module
// for the active locale (see guides/content). SSR renders it, so the localized
// title/description reach <head> and the prose is server-rendered.
export default function GuideShow({ slug }) {
  const { locale } = useI18n()
  const content = guideContent(locale)
  const guide = content.guides[slug]

  return (
    <GuidePage title={guide.title} description={guide.description} backLabel={content.back}>
      <GuideBody body={guide.body} />
    </GuidePage>
  )
}
